import {
  SETTINGS_REQUEST,
  SETTINGS_SUCCESS,
  SETTINGS_ERROR,
  UPLOAD_LOGO_REQUEST,
  UPLOAD_LOGO_SUCCESS,
  UPLOAD_LOGO_ERROR,
  UPLOAD_LOGIN_DIALOG_IMAGE_REQUEST,
  UPLOAD_LOGIN_DIALOG_IMAGE_SUCCESS,
  UPLOAD_LOGIN_DIALOG_IMAGE_ERROR,
  UPLOAD_HERO_SLIDERS_REQUEST,
  UPLOAD_HERO_SLIDERS_SUCCESS,
  UPLOAD_HERO_SLIDERS_ERROR,
  DELETE_HERO_SLIDER_REQUEST,
  DELETE_HERO_SLIDER_SUCCESS,
  DELETE_HERO_SLIDER_ERROR,
  UPDATE_SETTINGS_REQUEST,
  UPDATE_SETTINGS_SUCCESS,
  UPDATE_SETTINGS_ERROR,
} from "./actionTypes";

const initialState = {
  loading: false,
  settings: null,
  error: null,
  uploadLoading: false,
  uploadError: null,
};

const SettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SETTINGS_REQUEST:
      return { ...state, loading: true, error: null };

    case SETTINGS_SUCCESS:
      return { ...state, loading: false, settings: action.payload, error: null };

    case SETTINGS_ERROR:
      return { ...state, loading: false, error: action.payload };

    case UPLOAD_LOGO_REQUEST:
    case UPLOAD_LOGIN_DIALOG_IMAGE_REQUEST:
    case UPLOAD_HERO_SLIDERS_REQUEST:
      return { ...state, uploadLoading: true, uploadError: null };

    case UPLOAD_LOGO_SUCCESS:
    case UPLOAD_LOGIN_DIALOG_IMAGE_SUCCESS:
    case UPLOAD_HERO_SLIDERS_SUCCESS:
      return { ...state, uploadLoading: false, uploadError: null };

    case UPLOAD_LOGO_ERROR:
    case UPLOAD_LOGIN_DIALOG_IMAGE_ERROR:
    case UPLOAD_HERO_SLIDERS_ERROR:
      return { ...state, uploadLoading: false, uploadError: action.payload };

    case DELETE_HERO_SLIDER_REQUEST:
      return { ...state, loading: true, error: null };

    case DELETE_HERO_SLIDER_SUCCESS:
      return { ...state, loading: false, error: null };

    case DELETE_HERO_SLIDER_ERROR:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_SETTINGS_REQUEST:
      return { ...state, loading: true, error: null };

    case UPDATE_SETTINGS_SUCCESS:
      return { ...state, loading: false, settings: action.payload, error: null };

    case UPDATE_SETTINGS_ERROR:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default SettingsReducer;


